// Menü klappt auf, wenn auf die Menü-Items klickt
function initMMAccordion() {
  const menus = document.querySelectorAll('.custom_menu');
  if (!menus.length) return;

  menus.forEach(menu => {
    const items = menu.querySelectorAll('.custom_menu-item');

    items.forEach(item => {
      const button = item.querySelector('.custom_button');
      if (!button) return;

      button.addEventListener('click', () => {
        items.forEach(i => {
          if (i !== item) i.classList.remove('open');
        });
        item.classList.toggle('open');
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", initMMAccordion);
document.addEventListener("shopify:section:load", initMMAccordion);

// Website nach unten verschieben
function adjustBodyOffset() {
  const menu = document.querySelector('.custom_container');
  if (!menu) return;

  const menuHeight = menu.offsetHeight;
  document.querySelector('main').style.paddingTop = menuHeight + "px";
}

document.addEventListener("DOMContentLoaded", adjustBodyOffset);
window.addEventListener("resize", adjustBodyOffset);

